import { Component } from '@angular/core';

@Component({
  selector: 'apicard-list',
  templateUrl: 'apicard-list.component.html',
  styleUrls: ['apicard-list.component.scss']
}) export class APICard_List_Component {

}
